






























































































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";
import { http } from "@/shared/https";
import { ReportFilter, ReportParameter } from "@/entities";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import Axios from "axios";
import XLSX from "xlsx";
import moment from "moment";

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";

@Component({
  components: {
    AdvanceSearchComponent,
  },
})
export default class ImpactReportComponent extends Vue {
  items: any = [];
  data: any = [];
  subIndicators: any = [];
  reportedLevels: any = [];
  sites: any = [];
  programms: any = [];
  selectedPath: any = "";
  activeNodes: any = [];
  isLoading: boolean = false;

  fields: Array<ReportFilter> = [];
  selectedParams: Array<ReportParameter> = [];

  refReport: string = "reportDataTable";
  headers: any = [
    { text: "Grant Code", value: "GrantCode", sortable: false },
    { text: "Title", value: "ProjectTitle", sortable: false },
    { text: "Indicator", value: "Sub_Ind_Name", sortable: false },
    { text: "Site", value: "Site", sortable: false },
    { text: "Baseline", value: "Baseline", sortable: false },
    { text: "Target", value: "Target", sortable: false },
    { text: "Value", value: "Value", sortable: false },
  ];

  mounted() {
    this.$services.indicatorReport.getFilters().then((resp: any) => {
      this.fields = resp.Filters;
      this.items = resp.Hierarchy;
      this.activeNodes = [this.items[0].Path];
    });
  }

  // generate the report
  generateReport() {
    this.data = [];
    this.isLoading = true;
    this.$services.indicatorReport
      .getProgressReport(this.activeNodes, this.selectedParams)
      .then((resp: any) => {
        this.isLoading = false;
        this.data = resp.data;
      });
  }

  // show grant summary
  showGrant(grantId: number) {
    let routeData = this.$router.resolve({
      name: "grantSummary",
      params: { grantId: grantId.toString() },
    });
    window.open(routeData.href, "_blank");
  }

  _btnExport() {
    let expotableItems: any = [];
    let defaultSheetName = "Sheet1";
    let defaultFileName = "Report";

    let expotableFields = this.headers.map(({ value, text }) => ({
      value,
      text,
    }));

    // @ts-ignore
    let filteredItems = this.$refs[this.refReport].$children[0].filteredItems;

    // Select items with exportable true
    expotableItems = filteredItems.map((o) =>
      expotableFields.reduce((acc, curr) => {
        if(curr.value === 'Sub_Ind_Name')
          acc[curr.text] = (o["Sub_Ind_Name"] && o["Option"]) ? 
          `${o["Sub_Ind_Name"]} (${o["Option"]})`: 
          ( o["Sub_Ind_Name"] ? o["Sub_Ind_Name"] : 
          `${o.Ind_Code}. ${o.Ind_Name}`)
        else
          acc[curr.text] = curr.value in o ? o[curr.value] : "";
        return acc;
      }, {})
    );

    let fileName = `${defaultFileName}_${moment().format("DD-MM-YYYY")}`;

    // Export to excel
    if (expotableItems) {
      var sheet1 = XLSX.utils.json_to_sheet(expotableItems);
      var wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, sheet1, defaultSheetName);
      XLSX.writeFile(wb, `${fileName}.csv`);
    }
  }
}
